import React, { useState, useEffect} from 'react';
import { ListProductsFeature } from '@app/src/views/Home/listProducts';
import { ModalAccountActivation } from '@app/src/common/session';
import { useLocation } from 'react-router-dom';
import { isClientEnv } from '@app/src/utils/validations';
import { useHistory } from 'react-router-dom';

const isClient = isClientEnv();

export const Home:React.FC = () => {
  const location = useLocation();
  const history = useHistory();

  const [isShowModal, setIsShowModal] = useState(false);
  let query = null;
  const [hash, setHash] = useState(null);

  useEffect(() => {
    if (isClient && 'URLSearchParams' in window) {
      query = new URLSearchParams(location.search);
      setHash(query.get('hash'));
    }
  }, []);

  const handleClickCloseModal = () => {
    setIsShowModal(false);
    history.push('/inicia-tu-sesion');
  };

  useEffect(() => {
    if (hash) {
      setIsShowModal(true);
    }
  }, [hash]);

  return(
  <React.Fragment>
    <ModalAccountActivation
      showModal={isShowModal}
      closeModal={handleClickCloseModal}
    />
    <ListProductsFeature />
  </React.Fragment>
)};
